<section class="cmn-innerpage-wrapper invoice-details">
  <div class="head">
    <div class="search-wrapper">
      <input
        type="text"
        class="cmn-header-search"
        placeholder="Search"
        (input)="onSearch($event)"
      />
    </div>
    <button
      class="cmn-add-btn"
      (click)="navigateTo('petty-cash/add-petty-cash')"
      *ngIf="canCreatePettyCash$ | async"
    >
      <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add New Entry
    </button>

  </div>
  <div class="sub-head">
    <ul>
      <li class="main">All Petty Cash</li>
      <!-- <li *ngIf="isEditableStatus()" class="delete" (click)="onRemoveInvoice()">
        <img src="assets/images/icons/icon-delete-li.svg" alt="Delete" />
        Cancel
      </li> -->
    </ul>
  </div>
  <div class="manual-journal-details-tab-wrapper">
    <div class="tab-left">
      <div class="tab-box-main-wrapper">
        <button
          *ngFor="let pettyCash of allPettyCash; let i = index"
          class="tab-custom-button"
          [class.active]="selectedTabIndex === i"
          (click)="selectTab(i)"
        >
          <div class="inn-box">
            <h2>
              {{
                pettyCash?.employeeData?.firstName +
                  " " +
                  pettyCash?.employeeData?.lastName
              }}
            </h2>
            <h3>{{ pettyCash?.pettyCashNumber }}</h3>
          </div>
          <div class="inn-box">
            <h6>{{ pettyCash?.createdAt | date : "dd MMM yyyy" }}</h6>
            <h5>{{ pettyCash?.billStatus }}</h5>
          </div>
          <div class="inn-box">
            <!-- <h4 class="grey">{{ bill?.orderData?.orderCode }}</h4> -->
          </div>
        </button>
      </div>
    </div>
    <div class="manual-journal-details-content-wrapper">
      <div>
        <div
          class="petty-cash-table-wrapper"
          *ngIf="pettyCashData?.length > 0"
        >
        <div class="petty-cash-balance">
          <p>Opening Balance : <span>{{currentData?.openingBalance}}</span></p>
          <p>Current Balance : <span>{{currentData?.currentBalance}}</span></p>
        </div>
          <table>
            <thead>
              <tr>
                <th>Sl No.</th>
                <!-- <th>#</th> -->
                <th>Date</th>
                <th>Description</th>
                <th>In</th>
                <th>Out</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="account-detail-row"
                *ngFor="let item of pettyCashData; let i = index"
              >
                <td>{{ i + 1 }}</td>
                <!-- <td>{{ item?.journalData?.journalNo }}</td> -->
                <td>{{ item?.createdAt | date : "dd MMM yyyy" }}</td>
                <td>{{ item?.description }}</td>
                <td>
                  {{ item?.type === "IN" ? ( (currentData?.currencyData?.currencyCode || 'AED') + ' ' + item?.amount ) : "--" }}
                </td>
                <td>
                  {{ item?.type === "OUT" ? ( (currentData?.currencyData?.currencyCode || 'AED') + ' ' + item?.amount ) : "--" }}
                </td>
                
                <td
                  [style.color]="
                    item?.activityStatus === 'Approved'
                      ? '#00a860'
                      : item?.activityStatus === 'Pending'
                      ? '#efbe12'
                      : item?.activityStatus === 'Rejected'
                      ? '#ab0010'
                      : ''
                  "
                >
                  {{ item?.activityStatus }}
                </td>

                <td>
                  <div class="mat-menu-wrapper" *ngIf="(canApproveRejectPettyCash$ | async)||(canEditPettyCash$ | async)">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="menu"
                      aria-label="Example icon-button with a menu"
                      *ngIf="item?.activityStatus === 'Pending'"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button
                      mat-menu-item
                      (click)="onEditActivity('petty-cash/add-petty-cash', item?.id)"
                      *ngIf="canEditPettyCash$ | async"
                    >
                      <span>Edit</span>
                    </button>
                      <button
                        mat-menu-item
                        (click)="handleApproval(item?.id, true)"
                        *ngIf="canApproveRejectPettyCash$ | async"
                      >
                        <span>Approve</span>
                      </button>
                      <button
                        mat-menu-item
                        (click)="handleApproval(item?.id, false)"
                        *ngIf="canApproveRejectPettyCash$ | async"
                      >
                        <span>Reject</span>
                      </button>
                    </mat-menu>
                  </div>
                </td>
              </tr>
              <tr class="total-row">
                <td
                  colspan="3"
                  style="text-align: right; font-weight: 500"
                ></td>
                <td style="font-weight: 500">{{currentData?.currencyData?.currencyCode || 'AED'}} {{ totalIn }}</td>
                <td style="font-weight: 500">{{currentData?.currencyData?.currencyCode || 'AED'}} {{ totalOut }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="loading">
          <div class="loading-message">Loading...</div>
        </div>
        <div *ngIf="pettyCashData?.length === 0">
          <div class="no-data-message">No entries found.</div>
        </div>
      </div>
    </div>
  </div>
</section>
